jQuery(function ($) {
	$('.saleAdCarousel').each(function () {
		const $this = $(this);
		const $items = $this.find('.saleAdCarousel__items');
		const $nextArrow = $this.find('.saleAdCarousel__next');
		const $prevArrow = $this.find('.saleAdCarousel__prev');

		$items.slick({
			autoplay: true,
			autoplaySpeed: 5000,
			slidesToShow: 3,
			infinite: true,
			slidesToScroll: 1,
			arrows: true,
			nextArrow: $nextArrow,
			prevArrow: $prevArrow,
			responsive: [
				{
					breakpoint: 830,
					settings: {
						slidesToShow: 2,
						centerMode: true,
						centerPadding: '5%',
					},
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 1,
						centerMode: true,
						centerPadding: '12%',
					},
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						centerMode: true,
						centerPadding: '12%',
					},
				},
			],
		});
	});
});
